const steps = [
  { num: '1', title: 'Что необходимо получить?', desc: 'Конкретный измеримый результат. Не «поработай над отчётом», а «отчёт о продажах за квартал в формате Excel с разбивкой по менеджерам и каналам».' },
  { num: '2', title: 'Зачем это нужно?', desc: 'Контекст задачи: почему это важно, на что повлияет результат. Сотрудник должен понимать смысл задачи, а не просто выполнять поручение.' },
  { num: '3', title: 'Какой результат считается хорошим?', desc: 'Чёткие критерии качества. Например: «В отчёте должны быть данные по всем менеджерам, корректные формулы и визуализация динамики».' },
  { num: '4', title: 'К какому сроку?', desc: 'Конкретная дата и время. Не «к концу недели», а «в четверг до 18:00». Для больших задач — промежуточные сроки.' },
  { num: '5', title: 'Какие ограничения?', desc: 'Чего делать нельзя, какие данные не использовать, с кем не согласовывать. Это уберегает от ошибок и лишних действий.' },
  { num: '6', title: 'Какие ресурсы доступны?', desc: 'Информация, доступы, бюджет, помощь коллег — всё, что может понадобиться сотруднику для выполнения задачи.' },
  { num: '7', title: 'Какие полномочия?', desc: 'Что сотрудник может решать сам, а что требует согласования. Например: «Формат отчёта — на твоё усмотрение, выводы согласуем вместе».' },
  { num: '8', title: 'Когда и как проверяем результат?', desc: 'Контрольные точки и формат проверки. Например: «В среду в 14:00 покажешь черновик, обсудим 15 минут».' },
  { num: '9', title: 'Как сотрудник понял задачу?', desc: 'Не «Всё понятно?», а «Расскажи своими словами, что нужно сделать, к какому сроку и какие первые шаги ты планируешь».' },
];

export default function HowToSetTasks() {
  return (
    <section id="skills" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как правильно ставить задачи
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Структура качественной постановки задачи: девять элементов, которые должен учитывать руководитель
        </p>

        <div className="space-y-4 mb-12">
          {steps.map((step) => (
            <div key={step.num} className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors flex gap-4">
              <div className="w-8 h-8 rounded-full bg-teal-600 text-white flex items-center justify-center text-sm font-bold flex-shrink-0 mt-0.5">
                {step.num}
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-sm mb-1">{step.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto">
          <h3 className="text-lg font-bold text-teal-800 mb-3">Проверка понимания задачи</h3>
          <p className="text-teal-700 text-sm leading-relaxed mb-3">
            Самый недооценённый элемент постановки задачи — проверка того, как сотрудник её понял. Фраза «Всё понятно?» не работает: сотрудник может ответить «да», но на самом деле не разобраться в деталях.
          </p>
          <p className="text-teal-700 text-sm leading-relaxed font-semibold">
            Более эффективный подход: попросить сотрудника своими словами сформулировать ожидаемый результат, срок и следующие действия. Если формулировка сотрудника совпадает с вашим пониманием — задача поставлена корректно. Если нет — нужно уточнить непонятные моменты.
          </p>
        </div>
      </div>
    </section>
  );
}